import { template as template_2d6dde9a9a09463ca30ed210d74652d2 } from "@ember/template-compiler";
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import RequestValidatedInput from 'client-portal/components/request/validated-input';
import pick from 'ember-composable-helpers/helpers/pick';
import t from 'ember-intl/helpers/t';
export default template_2d6dde9a9a09463ca30ed210d74652d2(`
  <div class="row">
    <div class="col-12" data-test-email>
      <label class="required" for="waitlist-email">
        {{t "site.waitlistIntake.fields.email"}}
      </label>
      <RequestValidatedInput @model={{@form}} @path="email" @isDirty={{@form.isDirty}}>
        <input
          type="email"
          id="waitlist-email"
          name="email"
          value={{@form.email}}
          {{on "input" (pick "target.value" (fn @onUpdate "email"))}}
          autocomplete="email"
        />
      </RequestValidatedInput>
      <label class="boolean" for="waitlist-email-consent">
        <input
          type="checkbox"
          id="waitlist-email-consent"
          name="emailConsent"
          checked={{@form.emailConsent}}
          {{on "change" (pick "target.checked" (fn @onUpdate "emailConsent"))}}
          data-test-email-consent
        />
        {{t "site.waitlistIntake.fields.emailConsent"}}
      </label>
    </div>
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
